import { units_11 } from "../constants.js";
import { convertUnits } from "./convert.js";

//Codigos que se ven en los formularios
export const airemissionsCodes = {
  carbon_dioxide: "Air1",
  carbon_monoxide: "Air2",
  particulate_material: "Air3",
  volatile_organic_compounds: "Air4",
  sulfur_oxides: "Air5",
  nitrogen_oxides: "Air6",
  chlorofluorocarbons: "Air7",
  hydrochlorofluorocarbons: "Air8",
  hydrofluorocarbons: "Air9",
  hydrofluoroolefins: "Air10",
  perfluorocarbons: "Air11",
  substances_exhaust_ozone_layer: "Air12",
  ozone: "Air13",
  toxic_or_dangerous_atmospheric_pollutants: "Air14",
  ammonia: "Air15",
  propane: "Air16",
  isobutane: "Air17",
  propylene: "Air18",
  ethylene: "Air19",
  hexafluoroethane: "Air20",
  octafluoropropane: "Air21",
  chlorotrifluoromethane: "Air22",
  chlorodifluoromethane: "Air23",
  tetrafluoroethane: "Air24",
  trifluoromethane: "Air25",
  pentafluoroethane: "Air26",
  hexafluoropropylene: "Air27",
  hydrogen: "Air28",
  methane: "Air29",
  oxygen: "Air30",
  nitrogen: "Air31",
  hydrogen_sulfide: "Air32",
  carbon_disulfide: "Air33",
  nitrous_oxide: "Air34",
  hydrochlorofluorocarbons_ref:"Ref1",
  hydrofluorocarbons_ref:"Ref2",
  hydrofluoroolefins_ref:"Ref3",
  perfluorocarbonos_ref:"Ref4"
  // r_22: "Ref1",
  // r_123: "Ref2",
  // r_134a: "Ref3",
  // r_404a: "Ref4",
  // r_407a: "Ref5",
  // r_407c: "Ref6",
  // r_410a: "Ref7",
  // r_417a: "Ref8",
  // r_422d: "Ref9",
  // r_427a: "Ref10",
  // r_438a: "Ref11",
  // r_507a: "Ref12",
  // r_11: "Ref13",
  // r_12: "Ref14",
  // r_113: "Ref15",
  // r_114: "Ref16",
  // r_115: "Ref17",
  // r_600a: "Ref18",
  // r_290: "Ref19",
  // r_717: "Ref20",
  // r_718: "Ref21",
  // r_744: "Ref22",
};

//Codigos de los indicadores que se ven en el dashboard
export const airemissionsKPIsCodes = {
  total_carbon_dioxide: "KPIair1",
  total_carbon_monoxide: "KPIair2",
  total_particulate_material: "KPIair3",
  total_volatile_organic_compounds: "KPIair4",
  total_sulfur_oxides: "KPIair5",
  total_nitrogen_oxides: "KPIair6",
  total_chlorofluorocarbons: "KPIair7",
  total_hydrochlorofluorocarbons: "KPIair8",
  total_hydrofluorocarbons: "KPIair9",
  total_hydrofluoroolefins: "KPIair10",
  total_perfluorocarbons: "KPIair11",
  total_substances_exhaust_ozone_layer: "KPIair12",
  total_ozone: "KPIair13",
  total_toxic_or_dangerous_atmospheric_pollutants: "KPIair14",
  total_ammonia: "KPIair15",
  total_propane: "KPIair16",
  total_isobutane: "KPIair17",
  total_propylene: "KPIair18",
  total_ethylene: "KPIair19",
  total_hexafluoroethane: "KPIair20",
  total_octafluoropropane: "KPIair21",
  total_chlorotrifluoromethane: "KPIair22",
  total_chlorodifluoromethane: "KPIair23",
  total_tetrafluoroethane: "KPIair24",
  total_trifluoromethane: "KPIair25",
  total_pentafluoroethane: "KPIair26",
  total_hexafluoropropylene: "KPIair27",
  total_hydrogen: "KPIair28",
  total_methane: "KPIair29",
  total_oxygen: "KPIair30",
  total_nitrogen: "KPIair31",
  total_hydrogen_sulfide: "KPIair32",
  total_carbon_disulfide: "KPIair33",
  total_nitrous_oxide: "KPIair34",
  total_ref_hydrochlorofluorocarbons: "KPIref1",
  total_ref_hydrofluorocarbones: "KPIref2",
  total_ref_hydrofluoroolefin: "KPIref3",
  total_ref_perfluorocarbons: "KPIref4",
};

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
export function airemissionsFormulasIndicators(field, year, data, baseline) {
  switch (field) {
    case "total_carbon_dioxide":
      
      return (
      { total:  data["carbon_dioxide"]?.[year].total / baseline,
        unit: data["carbon_dioxide"]?.[year].unit
  });
    case "total_carbon_monoxide":
      return (
        { total:  data["carbon_monoxide"]?.[year].total / baseline,
          unit: data["carbon_monoxide"]?.[year].unit
    });
    case "total_particulate_material":
      return (
        { total:  data["particulate_material"]?.[year].total / baseline,
          unit: data["particulate_material"]?.[year].unit
    });
    case "total_volatile_organic_compounds":
      return (
        { total:  data["volatile_organic_compounds"]?.[year].total / baseline,
          unit: data["volatile_organic_compounds"]?.[year].unit
    });
    case "total_sulfur_oxides":
      return (
        { total:  data["sulfur_oxides"]?.[year].total / baseline,
          unit: data["sulfur_oxides"]?.[year].unit
    });
    case "total_nitrogen_oxides":
      return (
        { total:  data["nitrogen_oxides"]?.[year].total / baseline,
          unit: data["nitrogen_oxides"]?.[year].unit
    });
    case "total_chlorofluorocarbons":
      return (
        { total:  data["chlorofluorocarbons"]?.[year].total / baseline,
          unit: data["chlorofluorocarbons"]?.[year].unit
    });
    case "total_hydrochlorofluorocarbons":
      return (
        { total:  data["hydrochlorofluorocarbons"]?.[year].total / baseline,
          unit: data["hydrochlorofluorocarbons"]?.[year].unit
    });
    case "total_hydrofluorocarbons":
      return (
        { total:  data["hydrofluorocarbons"]?.[year].total / baseline,
          unit: data["hydrofluorocarbons"]?.[year].unit
    });
    case "total_hydrofluoroolefins":
      return (
        { total:  data["hydrofluoroolefins"]?.[year].total / baseline,
          unit: data["hydrofluoroolefins"]?.[year].unit
    });
    case "total_perfluorocarbons":
      return (
        { total:  data["perfluorocarbons"]?.[year].total / baseline,
          unit: data["perfluorocarbons"]?.[year].unit
    });
    case "total_substances_exhaust_ozone_layer":
      return (
        { total:  data["substances_exhaust_ozone_layer"]?.[year].total / baseline,
          unit: data["substances_exhaust_ozone_layer"]?.[year].unit
    });
    case "total_ozone":
      return (
        { total:  data["ozone"]?.[year].total / baseline,
          unit: data["ozone"]?.[year].unit
    });
    case "total_toxic_or_dangerous_atmospheric_pollutants":
      return (
        { total:  data["toxic_or_dangerous_atmospheric_pollutants"]?.[year].total / baseline,
          unit: data["toxic_or_dangerous_atmospheric_pollutants"]?.[year].unit
    });
    case "total_ammonia":
      return (
        { total:  data["ammonia"]?.[year].total / baseline,
          unit: data["ammonia"]?.[year].unit
    });
    case "total_propane":
      return (
        { total:  data["propane"]?.[year].total / baseline,
          unit: data["propane"]?.[year].unit
    });
    case "total_isobutane":
      return (
        { total:  data["isobutane"]?.[year].total / baseline,
          unit: data["isobutane"]?.[year].unit
    });
    case "total_propylene":
      return (
        { total:  data["propylene"]?.[year].total / baseline,
          unit: data["propylene"]?.[year].unit
    });
    case "total_ethylene":
      return (
        { total:  data["ethylene"]?.[year].total / baseline,
          unit: data["ethylene"]?.[year].unit
    });
    case "total_hexafluoroethane":
      return (
        { total:  data["hexafluoroethane"]?.[year].total / baseline,
          unit: data["hexafluoroethane"]?.[year].unit
    });
    case "total_octafluoropropane":
      return (
        { total:  data["octafluoropropane"]?.[year].total / baseline,
          unit: data["octafluoropropane"]?.[year].unit
    });
    case "total_chlorotrifluoromethane":
      return (
        { total:  data["chlorotrifluoromethane"]?.[year].total / baseline,
          unit: data["chlorotrifluoromethane"]?.[year].unit
    });
    case "total_chlorodifluoromethane":
      return (
        { total:  data["chlorodifluoromethane"]?.[year].total / baseline,
          unit: data["chlorodifluoromethane"]?.[year].unit
    });
    case "total_tetrafluoroethane":
      return (
        { total:  data["tetrafluoroethane"]?.[year].total / baseline,
          unit: data["tetrafluoroethane"]?.[year].unit
    });
    case "total_trifluoromethane":
      return (
        { total:  data["trifluoromethane"]?.[year].total / baseline,
          unit: data["trifluoromethane"]?.[year].unit
    });
    case "total_pentafluoroethane":
      return (
        { total:  data["pentafluoroethane"]?.[year].total / baseline,
          unit: data["pentafluoroethane"]?.[year].unit
    });
    case "total_hexafluoropropylene":
      return (
        { total:  data["hexafluoropropylene"]?.[year].total / baseline,
          unit: data["hexafluoropropylene"]?.[year].unit
    });
    case "total_hydrogen":
      return (
        { total:  data["hydrogen"]?.[year].total / baseline,
          unit: data["hydrogen"]?.[year].unit
    });
    case "total_methane":
      return (
        { total:  data["methane"]?.[year].total / baseline,
          unit: data["methane"]?.[year].unit
    });
    case "total_oxygen":
      return (
        { total:  data["oxygen"]?.[year].total / baseline,
          unit: data["oxygen"]?.[year].unit
    });
    case "total_nitrogen":
      return (
        { total:  data["nitrogen"]?.[year].total / baseline,
          unit: data["nitrogen"]?.[year].unit
    });
    case "total_hydrogen_sulfide":
      return (
        { total:  data["hydrogen_sulfide"]?.[year].total / baseline,
          unit: data["hydrogen_sulfide"]?.[year].unit
    });
    case "total_carbon_disulfide":
      return (
        { total:  data["carbon_disulfide"]?.[year].total / baseline,
          unit: data["carbon_disulfide"]?.[year].unit
    });
    case "total_nitrous_oxide":
      return (
        { total:  data["nitrous_oxide"]?.[year].total / baseline,
          unit: data["nitrous_oxide"]?.[year].unit
    });
    case "total_ref_hydrochlorofluorocarbons":
      return (
        { total:  data["hydrochlorofluorocarbons_ref"]?.[year] / baseline,
          unit: data["hydrochlorofluorocarbons_ref"]?.[year].unit
    });
    case "total_ref_hydrofluorocarbones":
      return (
        { total:  data["hydrofluorocarbons_ref"]?.[year] / baseline,
          unit: data["hydrofluorocarbons_ref"]?.[year].unit
    });
    case "total_ref_hydrofluoroolefin":
      return (
        { total:  data["hydrofluoroolefins_ref"]?.[year] / baseline,
          unit: data["hydrofluoroolefins_ref"]?.[year].unit
    });
    case "total_ref_perfluorocarbons":
      return (
        { total:  data["perfluorocarbonos_ref"]?.[year] / baseline,
          unit: data["perfluorocarbonos_ref"]?.[year].unit
    });
    default:
      return false;
  }
}

// Relación de conversiones, con más detalles para ppm, flujo volumétrico y masa.
const conversionRates = {
  // Concentración (ppm, mg/m³, µg/m³, etc.)
  "ppm": {
    "mg/m3": (value) => value * (1.225 / 24.45), // ppm a mg/m³ (Aire a condiciones estándar)
    "µg/m3": (value) => value * (1.225 / 24.45) * 1000, // ppm a µg/m³
    "ng/m3": (value) => value * (1.225 / 24.45) * 1000000, // ppm a ng/m³
  },
  "mg/m3": {
    "ppm": (value) => value * (24.45 / 1.225), // mg/m³ a ppm
    "µg/m3": (value) => value * 1000, // mg/m³ a µg/m³
    "ng/m3": (value) => value * 1000000, // mg/m³ a ng/m³
  },
  "µg/m3": {
    "ppm": (value) => value / (1.225 / 24.45) / 1000, // µg/m³ a ppm
    "mg/m3": (value) => value / 1000, // µg/m³ a mg/m³
    "ng/m3": (value) => value * 1000, // µg/m³ a ng/m³
  },
  "ng/m3": {
    "ppm": (value) => value / (1.225 / 24.45) / 1000000, // ng/m³ a ppm
    "mg/m3": (value) => value / 1000000, // ng/m³ a mg/m³
    "µg/m3": (value) => value / 1000, // ng/m³ a µg/m³
  },

  // Flujo Volumétrico a Flujo de Masa (por ejemplo, m³/h a kg/h)
  "m3/h": {
    "kg/h": (value, density) => value * density, // m³/h a kg/h (flujo volumétrico a masa)
    "g/s": (value, density) => value * density / 3600, // m³/h a g/s (flujo volumétrico a masa)
  },
  "m3/s": {
    "kg/h": (value, density) => value * density * 3600, // m³/s a kg/h
    "g/s": (value, density) => value * density * 1000, // m³/s a g/s
  },

  // Conversiones entre masa
  "g/s": {
    "kg/h": (value) => value * 3600 / 1000, // g/s a kg/h
    "m3/h": (value, density) => value * 3600 / density, // g/s a m³/h
  },
  "kg/h": {
    "g/s": (value) => value * 1000 / 3600, // kg/h a g/s
    "m3/h": (value, density) => value / density, // kg/h a m³/h
  },
};

// Función de conversión
export function convertAirEmissionsFinal(value, fromUnit, toUnit, material,density = 1.225) {
  // La densidad se usa para las conversiones de flujo de masa (m³/h, kg/h, etc.)

  // Validación de entradas
  if (value === "" || value === null || value === undefined) {
    throw new Error("El valor no puede estar vacío o nulo.");
  }
  
  if (!fromUnit || !toUnit) {
    //throw new Error("Ambas unidades de origen y destino deben ser proporcionadas.");
    return value
  }

  if (fromUnit === toUnit) {
    // Si las unidades son iguales, no hacer ninguna conversión
    return value;
  }

  if (!conversionRates[fromUnit] || !conversionRates[fromUnit][toUnit]) {
    return "Conversion no soportada"
    //throw new Error(`Conversión no soportada entre las unidades ${fromUnit} y ${toUnit}.`);
  }

  // Realizar la conversión
  return conversionRates[fromUnit][toUnit](value, density);
}

//Suma los valores de los campos/claves pasadas como parametros
function addData(keys, year, data, unitSelected) {
  let suma = 0;
  //tomo como referencia el kwh
  for (let clave of keys) {
    if (data.hasOwnProperty(clave)) {
      suma +=
        convertUnits(
          data[clave]?.[year].total,
          data[clave]?.[year].unit,
          unitSelected
        ) || 0;
    }
  }

  return suma;
}

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineAirEmissionsUnits = (value) => {
  return units_11.map(unit => ({ ...unit, text: unit.name }));
};
